import { defaultLocale, type Locale } from "@/lib/i18n/locales";
import {
  expertiseCityHasLocaleTranslation,
  getExpertiseCityBySlug,
  getExpertiseEnumBySlug,
} from "@/lib/strings/expertiseCityStrings";
import { localizedPath } from "./navigation";

/**
 * For the language switcher (client-safe): if the path is an expertise city URL
 * that has no translation in `targetLocale`, return the general expertise path instead.
 */
export function localizedPathWithExpertiseCityFallback(
  pathWithoutLocale: string,
  targetLocale: Locale,
): string {
  const normalized = pathWithoutLocale.startsWith("/")
    ? pathWithoutLocale
    : `/${pathWithoutLocale}`;
  const parts = normalized.split("/").filter(Boolean);

  if (parts[0] !== "expertise" || parts.length < 3) {
    return localizedPath(normalized, targetLocale);
  }

  const slug = parts[1]!;
  const citySlug = parts[2]!;
  const expertiseEnum = getExpertiseEnumBySlug(slug);
  if (
    expertiseEnum &&
    getExpertiseCityBySlug(expertiseEnum, citySlug, defaultLocale) &&
    !expertiseCityHasLocaleTranslation(targetLocale, expertiseEnum, citySlug)
  ) {
    return localizedPath(`/expertise/${slug}`, targetLocale);
  }

  return localizedPath(normalized, targetLocale);
}
